query tiposSistemaTribunalSelect($where: EnumItemDTOFilterInput) {
    data: tiposSistemaTribunal(where: $where)  {
        label
        value
    }
}